import React from "react";
import { RxCross1 } from "react-icons/rx";

function FilterSide({
  filterData,
  onChange,
  apply,
  clearFilter,
  onClose,
  questionTypes,
  setSelectedValue,
  selectedValue,
}) {
  const options = [
    { label: "Concept", value: "concept" },
    { label: "Aptitude", value: "aptitude" },
    { label: "Random", value: "random" }
  ];
  const isApplyEnabled =
    Object.values(filterData).some((value) => value === true) || selectedValue;
  return (
    <div className="fixed z-50 inset-0 overflow-hidden duration-300 ease-in-out">
      <div className="flex items-center max-w-sm min-h-screen text-center">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div
            className="absolute inset-0 bg-gray-500 opacity-80"
            onClick={onClose}
          ></div>
        </div>

        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>

        <div
          className="absolute right-0 inline-block w-full min-h-screen bg-white rounded-l-xl space-y-4 px-4 pt-5 pb-4 text-left overflow-hidden transform transition-all sm:max-w-sm sm:w-full"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
        >
          <div className="text-black w-full bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-lg px-4 py-2.5 text-center inline-flex items-center justify-between">
            <p className="text-lg"> Filter & Short</p>
            <button
              id="dropdownDefault"
              data-dropdown-toggle="dropdown"
              className=""
              type="button"
              onClick={onClose}
            >
              <svg className="w-4 h-4 ml-2" viewBox="0 0 16 16">
                <RxCross1 />
              </svg>
            </button>
          </div>
          <div
            id="dropdown"
            className="p-3 text-black rounded-lg space-y-4"
          >
            <div className="rounded-lg space-y-2 shadow p-4">
              <h6 className="text-lg font-medium text-gray-700">
                Question Type
              </h6>
              <ul
                className="space-y-2 text-sm"
                aria-labelledby="dropdownDefault"
              >
                {questionTypes.map((type) => (
                  <li
                    key={type.id}
                    className="flex items-center justify-between"
                  >
                    <label
                      htmlFor={type.id}
                      className="ml-2 text-md capitalize font-medium text-gray-700"
                    >
                      {type.label}
                    </label>
                    <input
                      id={type.id}
                      type="checkbox"
                      name={type.id}
                      checked={filterData[type.id]}
                      onChange={onChange}
                      className="w-4 h-4 bg-gray-100 border-gray-300 rounded-md text-primary-600"
                    />
                  </li>
                ))}
              </ul>
            </div>
            <div className="rounded-lg space-y-2 shadow p-4">
              <h6 className=" text-lg font-medium text-gray-700">
                Question Category
              </h6>
              <div className="space-y-2">
                {options.map((option, index) => (
                  <div key={index} className="flex items-center">
                    <input
                      type="radio"
                      id={`option${index}`}
                      name="options"
                      value={option.value}
                      className="hidden"
                      checked={selectedValue === option.value}
                      onChange={(e) => setSelectedValue(e.target.value)}
                    />
                    <label
                      htmlFor={`option${index}`}
                      className="cursor-pointer flex items-center space-x-2"
                    >
                      <span
                        className={
                          selectedValue === option.value
                            ? "text-[#124699]"
                            : ""
                        }
                      >
                        {option.label}
                      </span>
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="w-full flex items-center space-x-4">
            <button
              type="button"
              onClick={clearFilter}
              data-behavior="cancel"
              className="w-full rounded-md border border-[#124699] shadow-sm px-4 py-2 bg-white text-base font-medium text-[#124699] hover:text-[#124699] focus:outline-none focus:ring-0 sm:text-sm"
            >
              Clear
            </button>
            <button
              type="button"
              onClick={apply}
              data-behavior="commit"
              className={`w-full rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium sm:text-sm ${
                isApplyEnabled
                  ? "bg-[#124699] text-white hover:bg-[#124699]"
                  : "bg-gray-300 text-gray-500 cursor-not-allowed"
              }`}
              disabled={!isApplyEnabled}
            >
              Apply Filter
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
export default FilterSide;
